import { render, staticRenderFns } from "./outside.vue?vue&type=template&id=03c6da9a&scoped=true"
import script from "./outside.vue?vue&type=script&lang=js"
export * from "./outside.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03c6da9a",
  null
  
)

export default component.exports